import type { User } from "@supabase/supabase-js";

/**
 * Resolves a display-ready first name from auth metadata. Checks the
 * explicit first_name field first — the one #164's signup field and the
 * Settings "Add your name" editor both write via supabase.auth.updateUser()
 * — then falls back to whatever name an SSO provider populated (full_name /
 * name), taking just the first word. Returns null when nothing usable is
 * set; callers should show a generic fallback in that case, not their own
 * ad-hoc metadata reads (mirrors get_or_create_inbox_address's
 * coalesce(first_name, full_name, name) so the frontend and the DB agree).
 */
export function getFirstName(user: User | null | undefined): string | null {
  const meta = (user?.user_metadata || {}) as Record<string, unknown>;
  const explicit = typeof meta.first_name === "string" ? meta.first_name.trim() : "";
  if (explicit) return explicit;

  const fallbackSource =
    (typeof meta.full_name === "string" && meta.full_name) ||
    (typeof meta.name === "string" && meta.name) ||
    "";
  const firstWord = fallbackSource.trim().split(/\s+/)[0];
  return firstWord || null;
}
